import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { Select, SelectProps } from "antd";

import { t } from "i18next";
import { Props } from "src/common/entity/props.entity";
import { MembershipCardEntity } from "src/module/membershipCard/entity/membership.card.entity";
import membershipCardService from "src/module/membershipCard/service/membership.card.service";
import styled from "@emotion/styled";

const { Option } = Select;

interface IProps extends Props {
	isMultiple?: boolean;
}

const SubscriptionSelector: FC<IProps> = (props: IProps) => {
	const [dataArr, setDataArr] = useState<MembershipCardEntity[]>([]);
	const [title, setTitle] = useState<string | undefined>(undefined);

	const multipleConfigs = useMemo(() => {
		if (props.isMultiple) {
			return {
				mode: "multiple",
				showArrow: true,
			} as SelectProps;
		}
	}, [props.isMultiple]);

	const getValue = useMemo(() => {
		if (!props.value) return void 0;
		if (props.isMultiple) {
			return props.value?.split(",").map((item: string) => Number(item)) || [];
		}
		return props?.value;
	}, [props.isMultiple, props.value]);

	const init = useCallback(async () => {
		const params = { ...(title && { title }) };
		const res = await membershipCardService.list(params);
		if (res.data.code === 200) setDataArr(res.data.data);

		// let flag = false;
		// const list = res.data.data;
		// list.forEach((item: MembershipCardEntity) => {
		// 	if (item.id === getValue) {
		// 		flag = true;
		// 	}
		// });

		// if (!flag && getValue) {
		// 	const { data } = await membershipCardService.detail(getValue);
		// 	setDataArr([...list, data.data]);
		// }
	}, [title]);

	useEffect(() => {
		init();
	}, [init]);

	const changeData = (e: any) => {
		const finalValue = props.isMultiple ? e.join(",") : e;
		props.onChange?.(finalValue);
		setTitle(void 0);
	};

	return (
		<Container>
			<Select
				showSearch
				value={getValue}
				onChange={changeData}
				onSearch={setTitle}
				allowClear
				optionFilterProp={"children"}
				placeholder={t("pleaseSelectMembershipCard")}
				{...multipleConfigs}
			>
				{dataArr &&
					dataArr.map((item) => {
						return (
							<Option key={item.id} value={item.id}>
								{item.title}
							</Option>
						);
					})}
			</Select>
		</Container>
	);
};

const Container = styled.div`
	.ant-select {
		width: 100%;
	}
`;

export default SubscriptionSelector;
